export default __webpack_public_path__ + "static/lb-01-46ecefe7cf0eab7952e46468e0456b83.webp";